import React from 'react';
import {t} from '@lingui/core/macro';

import {IBatchResult} from 'entities/monitor';

import MainModal from '../../../../../shared/ui/Modal/MainModal';
import ModalBodyWrapper from '../../../../../shared/ui/Modal/ModalBodyWrapper';
import ProgressBar from '../../../../../shared/ui/ProgressBar/ProgressBar';
import UsersExportResponseHandler from './UsersExportResponseHandler';

interface IIncidentsExportModalProps {
    open: boolean,
    handleClose: () => void,
    result?: IBatchResult,
    entityName?: string,
    progress?: number,
}

const UsersExportModal: React.FC<IIncidentsExportModalProps> = ({
    open,
    handleClose,
    result,
    entityName = 'пользователей',
    progress,
}) => {
    return (
        <MainModal
            header="Экспорт"
            open={open}
            handleClose={handleClose}
            size="md"
        >
            {
                (result)
                    ? <UsersExportResponseHandler result={result} entityName={entityName}/>
                    : <ModalBodyWrapper>
                        {progress !== undefined && (
                            <ProgressBar percent={progress} title={t`Выполняется экспорт…`}/>
                        )}
                    </ModalBodyWrapper>
            }
        </MainModal>
    );
};

export default UsersExportModal;